import { createContext } from 'react'

import type { IFiltersProps } from '@appTypes/model/filters.model'

export interface IFiltersContext {
  collectQueryParams: (data: IFiltersProps, array?: string[]) => void
}

export const FiltersContext = createContext<IFiltersContext>({} as IFiltersContext)
